import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Clients } from 'src/app/models/interfaces/clients';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { Helps } from 'src/app/libs/helps';
import { Stores } from '../../interfaces/stores';
import { Users } from 'src/app/models/interfaces/users';

@Component({
  selector: 'app-admin-store',
  templateUrl: './admin-store.component.html',
  styleUrls: ['./admin-store.component.css']
})
export class AdminStoreComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private router: Router,
    private helps: Helps
  ) { }

  ngOnInit(): void {
    this.level = this.helps.getToken()?.level;
    let data = this.helps.getToken()?.data as Users;
    console.log("data:",data),
    this.hideRound = (data?.hide_rounds==1)?1:0;
    console.log("hideRounds:",data?.hide_rounds),
    this.getClient();
  }
  //html
  loadingAdditionalContent:boolean=false;
  additionalHtmlContent='';
  level: number = 0;
  dataId: number = 0;
  facility_id: number = 0;
  hideRound: number = 0;

  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Clients>();
  id: number = 0;
  active = 0;
  items: any;
  view: number = 1;
  form = new UntypedFormGroup({
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(),
    owner: new UntypedFormControl(''),
    owner_phone: new UntypedFormControl(''),
    content:new UntypedFormControl(''),
    rut: new UntypedFormControl(''),
    turn: new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    img_path: new UntypedFormControl(''),
    facility_id: new UntypedFormControl(0),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
  });
  facilitys: Facility[];
  getClient() {
    this.getFacility();
    this.api.getMyStore().subscribe(
      (response) => {
        var store=response.data as Stores;
        this.form.patchValue(store);
        this.additionalHtmlContent=store.content;
        this.dataId = response.data['id'];
        this.facility_id = response.data['facility_id']
        this.form.disable();
      },
      (error) => {
        this.toast.warning('', 'Recinto no encontrada');
        this.router.navigate(['/control-ingreso/bodegas/gestion']);
      }
    );
  }
  getFacility() {
    this.api.getAllFacility().subscribe((res) => {
      this.facilitys = res.data as Facility[];
    });
  }
  update() {
    this.api.updateStore(this.form).subscribe(
      (response) => {
        this.toast.success(
          response.msg,
          'Gestión Recinto'
        );
        this.record.emit(response.data as Clients);
        this.success.emit(true);
      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error', {
          enableHtml: true,
          closeButton: true
        });
      }
    );
  }
  onFormatRut(value: any) {
    let rut = value.target.value;
    if (rut.length > 8) {
      rut = formatRut(rut, RutFormat.DOTS_DASH)
      this.form
        .get('rut')
        ?.setValue(rut);
    }
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
}
